import { Textarea } from "@mantine/core";
import { HttpError, IResourceComponentsProps } from "@refinedev/core";
import { Edit, useForm } from "@refinedev/mantine";
import DateTimePicker from "components/common/DateTimePicker";
import { UpdateTeaAddonRenewalRun } from "entities/tea_addon_renewal_run";

export const TeaAddonRenewalRunEdit: React.FC<
  IResourceComponentsProps
> = () => {
  const { getInputProps, saveButtonProps } = useForm<
    UpdateTeaAddonRenewalRun,
    HttpError,
    UpdateTeaAddonRenewalRun
  >({
    initialValues: {
      range_start_at: new Date(),
      range_end_at: new Date(),
      notes: "",
    },
  });

  return (
    <Edit
      saveButtonProps={saveButtonProps}
      canDelete={false}
      title="Update Tea Addon Renewal Run"
    >
      <DateTimePicker
        type="date"
        label="Range Start At"
        defaultValue={new Date()}
        mt="sm"
        min={0}
        max={10}
        {...getInputProps("range_start_at")}
      />
      <DateTimePicker
        type="date"
        label="Range End At"
        defaultValue={new Date()}
        mt="sm"
        min={0}
        max={10}
        {...getInputProps("range_end_at")}
      />
      <Textarea
        defaultValue=""
        mt="sm"
        label="Notes"
        {...getInputProps("notes")}
      />
    </Edit>
  );
};
